import { render, staticRenderFns } from "./UnauthFooter.vue?vue&type=template&id=fe97c5f6&"
import script from "./UnauthFooter.vue?vue&type=script&lang=js&"
export * from "./UnauthFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports